module.exports = __webpack_public_path__ + "static/media/banner4.643a20f7.jpg";